import { FC } from 'react';
import { Stack } from '@mui/material';
import { APP, ROUTES } from 'config';
import {
  ActionsMenu,
  Link,
  ListTotal,
  Table,
  TableToolbar,
  TableWrapper,
} from 'melp-design/components';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { newsCategoriesFiltersSchema, useNewsCategories } from 'store/news';
import { useSearchParams } from 'utils/navigation';
import { CategoryActions } from 'containers/news';
import { useMe } from 'state/Administrators';

export const CategoriesList: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { hasEditPermission } = useMe();

  const { searchParams: filters, navigate } = useSearchParams(
    newsCategoriesFiltersSchema,
  );

  const { data: categories, isLoading } = useNewsCategories(filters);

  return (
    <TableWrapper>
      <TableToolbar>
        <Stack gap="10px">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            gap="15px"
          >
            <ListTotal total={categories?.total} />

            <ActionsMenu
              type="spread"
              items={[
                {
                  label: t('common.create'),
                  color: 'primary',
                  disabled: !hasEditPermission(['news']),
                  onClick: () => history.push(ROUTES.news.categories.create),
                },
              ]}
            />
          </Stack>
        </Stack>
      </TableToolbar>

      <Table
        data={categories?.items ?? []}
        isLoading={isLoading}
        columns={[
          {
            id: 'name',
            header: t('common.systemName'),
            cell: ({ row: { original: category } }) => {
              return (
                <Link
                  label={category.name}
                  to={ROUTES.news.categories.details.replace(
                    ':id',
                    category.id,
                  )}
                />
              );
            },
          },
          {
            id: 'createdAt',
            header: t('marketplaceOrders.orderDate'),
            cell: ({ row: { original: category } }) =>
              moment(category.createdAt).format('l'),
          },
          {
            id: 'actions',
            cell: ({ row: { original: category } }) => (
              <CategoryActions
                id={category.id}
                name={category.name}
                type="compact"
              />
            ),
          },
        ]}
        pagination={
          categories && {
            count: categories.total,
            page: filters.page,
            pageSize: filters.pageSize,
            pageSizeOptions: APP.pagination.defaults.pageSize,
            onChange: (page, pageSize) => {
              navigate({ params: { page, pageSize } });
            },
          }
        }
      />
    </TableWrapper>
  );
};
